/** Opening an app's detail from a list.
 *
 *  The detail has an address, `/apps/:id`, so a reload or a shared link lands
 *  on it. Opened from a page it carries that page as its `background`: from
 *  1024px up the page stays drawn (filters, scroll) with the detail as a
 *  drawer over it; below, the detail is a page of its own
 *  (routes/apps/AppDrawer.tsx). */

import type { Location } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router-dom'

export interface DetailState {
  /** The page the detail was opened from; it stays drawn under the drawer. */
  background?: Location
}

export function appPath(appId: number): string {
  return `/apps/${appId}`
}

/** `open(appId)` shows that app over the current page, keeping the page's
 *  query (?range=) on the detail so it shows the same period. */
export function useOpenApp() {
  const navigate = useNavigate()
  const location = useLocation()
  return (appId: number) => {
    const bg = (location.state as DetailState | null)?.background ?? location
    navigate({ pathname: appPath(appId), search: bg.search }, { state: { background: bg } satisfies DetailState })
  }
}
